/** Tipos legados EQUIP-OFF / EQUIP-ON (v1.36.0) sem coluna path. */
const PATHS_EQUIPAMENTO_POR_ID = new Set([23, 24]);

/**
 * Path Vue destino do alerta. Preferência: coluna `tipos_notificacoes.path`.
 * Sem path: equipamento → /equipamentos; demais → /operacao.
 */
export function resolveNotificacaoPath(notif) {
  const stored = notif && notif.path != null ? String(notif.path).trim() : "";
  if (stored) {
    return stored;
  }
  if (notif && notif.id_equipamento != null) {
    return "/equipamentos";
  }
  const idTipo = Number(notif && notif.id_tipo_notificacao);
  if (PATHS_EQUIPAMENTO_POR_ID.has(idTipo)) {
    return "/equipamentos";
  }
  return "/operacao";
}

/**
 * Visibilidade do alerta para o usuário logado.
 * Superadmin vê tudo. Demais: linha permitida, ou alerta de equipamento
 * (path /equipamentos) do cliente (id_empresa) do usuário.
 */
export function notificacaoPertenceAoUsuario({
  notif,
  isSuperadmin,
  idsLinhas,
  idsEmpresas,
}) {
  if (isSuperadmin) {
    return true;
  }
  const linhas = idsLinhas instanceof Set ? idsLinhas : new Set();
  const empresas = idsEmpresas instanceof Set ? idsEmpresas : new Set();
  if (notif && notif.id_linha != null && linhas.has(String(notif.id_linha))) {
    return true;
  }
  if (resolveNotificacaoPath(notif) === "/equipamentos") {
    return (
      notif &&
      notif.id_empresa != null &&
      empresas.has(String(notif.id_empresa))
    );
  }
  return false;
}
